import { Reducer } from 'redux';
import { v4 as createUUID } from 'uuid';
import { ProcessStepCodesEnum } from 'app/features/Service/QueryPolicy/Pay/types';
import { PayState, PayActions, SERVICE_QUERY_POLICY_PAY__FETCH_POLICY_DETAIL_DONE, SERVICE_QUERY_POLICY_PAY__SET_ACCESSIBLE_STEP, SERVICE_QUERY_POLICY_PAY__SEND_OTP_DONE, SERVICE_QUERY_POLICY_PAY__RESEND_OTP_DONE, SERVICE_QUERY_POLICY_PAY__SET_POLICY_STATUS, SERVICE_QUERY_POLICY_PAY__UPDATE_CACHE, SERVICE_QUERY_POLICY_PAY__RESET_CACHE } from './types';

const initialState: PayState = {
  static: {},
  process: {
    accessibleSteps: [],
    confirmInfo: {
      otpAuth: {}
    }
  }
};

const payReducer: Reducer<PayState, PayActions> = (state = initialState, action): PayState => {
  switch (action.type) {
    // 取得保單明細 完成
    case SERVICE_QUERY_POLICY_PAY__FETCH_POLICY_DETAIL_DONE: {
      // 說明：取得保單明細完成後會導頁至「我要繳費流程」，因此將確認資料 (Step-1-1) 設為可訪問步驟。
      const accessibleSteps = [ProcessStepCodesEnum.ConfirmInfo];
      return { ...state, static: { ...state.static, detail: action.payload.response, paymentWSUUID: createUUID() }, process: { ...state.process, accessibleSteps } };
    }
    // 設置可訪問步驟
    case SERVICE_QUERY_POLICY_PAY__SET_ACCESSIBLE_STEP: {
      const currentStep = action.payload.step;
      const accessibleSteps = state.process.accessibleSteps.filter((step) => step !== currentStep).concat(currentStep);
      return { ...state, process: { ...state.process, accessibleSteps } };
    }
    // 發送 OTP 驗證碼 完成
    // 重新發送 OTP 驗證碼 完成
    case SERVICE_QUERY_POLICY_PAY__SEND_OTP_DONE:
    case SERVICE_QUERY_POLICY_PAY__RESEND_OTP_DONE: {
      return { ...state, process: { ...state.process, confirmInfo: { ...state.process.confirmInfo, otpAuth: { ...state.process.confirmInfo.otpAuth, otp: action.payload.response } } } };
    }
    // 設置保單狀態
    case SERVICE_QUERY_POLICY_PAY__SET_POLICY_STATUS: {
      return { ...state, policyStatus: { ...state.policyStatus, ...action.payload.status } };
    }
    // 更新流程資料緩存
    case SERVICE_QUERY_POLICY_PAY__UPDATE_CACHE: {
      return { ...action.payload.cache };
    }
    // 重置資料緩存
    case SERVICE_QUERY_POLICY_PAY__RESET_CACHE: {
      return { ...initialState };
    }
    // Default
    default:
      return state;
  }
};

export default payReducer;
